import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeProfileQueryKey } from './queryKey';
export const useCreateEmployeeProfile = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .post('/api/employeeProfile', model)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], old => (old ? [...old, result] : [result]));
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { createProfile: mutateAsync, isLoading };
};
export const useUpdateEmployeeProfile = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.put('/api/employeeProfile', model).then(res => res.data), {
        onSuccess: () => {
            queryClient.invalidateQueries([EmployeeProfileQueryKey.EmployeeProfiles]);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateProfile: mutateAsync, isLoading };
};
export const useDeleteEmployeeProfile = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((id) => api.base.delete(`/api/employeeProfile/Delete/${id}`).then(() => id), {
        onSuccess: (deletedId) => {
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], old => (old ? old.filter(e => e.id !== deletedId) : old));
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { deleteProfile: mutateAsync, isLoading };
};
export const useSetDefaultEmployeeProfile = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((id) => api.base
        .put(`/api/employeeProfile/SetDefault/${id}`)
        .then(res => res.data), {
        onSuccess: (updatedProfiles) => {
            if (!(updatedProfiles === null || updatedProfiles === void 0 ? void 0 : updatedProfiles.length))
                return;
            queryClient.setQueryData([EmployeeProfileQueryKey.EmployeeProfiles], old => {
                if (!old)
                    return old;
                return old.map(profile => {
                    const updated = updatedProfiles.find(p => p.id === profile.id);
                    return updated ? Object.assign(Object.assign({}, profile), { isDefault: updated.isDefault }) : profile;
                });
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { setDefault: mutateAsync, isLoading };
};
